// extracted by mini-css-extract-plugin
export default {"u":"style_u__zidiZ"};